export default [{
  sutra: 's1',
  vocabularies: [{
    no: '3.1',
    v1: 'ཁ་ན་མ་ཐོ་བ་མེད་པའི་ལུས་ཀྱི་ལས་དང་ལྡན་པ་ཡིན། ཁ་ན་མ་ཐོ་བ་མེད་པའི་ངག་གི་ལས་དང་ལྡན་པ་ཡིན། ཁ་ན་མ་ཐོ་བ་མེད་པའི་ཡིད་ཀྱི་ལས་དང་ལྡན་པ་ཡིན།་་་་་',
    v2: '無過失身、語、意業',
    v3: '不染身、口、意業',
    v5: '不念人惡',
    v4: '身不行他人長短；口不說他人長短；心不念他人長短',
    other: null,
  },
  {
    no: '3.2',
    v1: 'ལུས་ཀྱི་ལས་རྣམ་པར་མ་ཉམས་པ་ཡིན། ངག་གི་ལས་རྣམ་པར་མ་ཉམས་པ་ཡིན། ཡིད་ཀྱི་ལས་རྣམ་པར་མ་ཉམས་པ་ཡིན།་་་་་',
    v2: '不可壞身、語、意業',
    v3: '-',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '3.3',
    v1: 'ལུས་ཀྱི་ལས་མ་སྨད་པ་ཡིན། ངག་གི་ལས་མ་སྨད་པ་ཡིན། ཡིད་ཀྱི་ལས་མ་སྨད་པ་ཡིན།་་་་་',
    v2: '不可毀身、語、意業',
    v3: '-',
    v5: '使天下不得其短',
    v4: '身有所行不令他人得長短；口所言不令他人得長短；心所念不令他人得長短',
    other: null,
  },
  {
    no: '3.4',
    v1: 'ལུས་ཀྱི་ལས་མི་འཕྲོགས་པ་ཡིན། ངག་གི་ལས་མི་འཕྲོགས་པ་ཡིན། ཡིད་ཀྱི་ལས་མི་འཕྲོགས་པ་ཡིན།་་་་',
    v2: '不害身、語、意業',
    v3: '不害身、口、意業',
    v5: '仁慈至大，內性明了',
    v4: '身所行、口所言、心所念，無有能害者',
    other: null,
  },
  {
    no: '3.5',
    v1: 'ལུས་ཀྱི་ལས་མི་ཟློགས་པ་ཡིན། ངག་གི་ལས་མི་ཟློགས་པ་ཡིན། ཡིད་ཀྱི་ལས་མི་ཟློགས་པ་ཡིན།་་་་',
    v2: '不退轉身、語、意業',
    v3: '不退轉身、口、意業',
    v5: '一切衆邪莫能迴',
    v4: '身所行、口所言、心所念，無有能逮者',
    other: null,
  },
  {
    no: '3.6',
    v1: 'ལུས་ཀྱི་ལས་མི་འཁྲུགས་པ་ཡིན། ངག་གི་ལས་མི་འཁྲུགས་པ་ཡིན། ཡིད་ཀྱི་ལས་མི་འཁྲུགས་པ་ཡིན།་་་་',
    v2: '不可動身、語、意業',
    v3: '不動身、口、意業',
    v5: '一切衆邪莫能動',
    v4: '身所行、口所言、心所念，無有能動轉者',
    other: null,
  },
  {
    no: '3.7',
    v1: 'ལུས་ཀྱི་ལས་བསྔགས་པ་ཡིན། ངག་གི་ལས་བསྔགས་པ་ཡིན། ཡིད་ཀྱི་ལས་བསྔགས་པ་ཡིན།་་་',
    v2: '殊勝身、語、意業',
    v3: '應讚歎身、口、意業',
    v5: '殊過弟子別覺之上',
    v4: '-',
    other: null,
  },
  {
    no: '3.8',
    v1: 'ལུས་ཀྱི་ལས་རྣམ་པར་དག་པ་ཡིན། ངག་གི་ལས་རྣམ་པར་དག་པ་ཡིན། ཡིད་ཀྱི་ལས་རྣམ་པར་དག་པ་ཡིན།་་་',
    v2: '淸淨身、語、意業',
    v3: '淸淨身、口、意業',
    v5: '身、口、身、口、意淨',
    v4: '身所行淨潔；口所言淨潔；心所念淨潔',
    other: null,
  },
  {
    no: '3.9',
    v1: 'ལུས་ཀྱི་ལས་ཉེ་བར་ཉོན་མོངས་པ་མེད་པ་ཡིན། ངག་གི་ལས་ཉེ་བར་ཉོན་མོངས་པ་མེད་པ་ཡིན། ཡིད་ཀྱི་ལས་ཉེ་བར་ཉོན་མོངས་པ་མེད་པ་ཡིན།་་་་་་་་་་',
    v2: '無染身、語、意業',
    v3: '離煩惱身、口、意業',
    v5: 'ྀ',
    v4: '身所行無瑕穢；口所言無瑕穢；心所念無瑕穢',
    other: null,
  },
  {
    no: '3.10',
    v1: 'ལུས་ཀྱི་ལས་ཡེ་ཤེས་ཀྱི་སྔོན་དུ་འགྲོ་བ་ཡིན། ངག་གི་ལས་ཡེ་ཤེས་ཀྱི་སྔོན་དུ་འགྲོ་བ་ཡིན། ཡིད་ཀྱི་ལས་ཡེ་ཤེས་ཀྱི་སྔོན་དུ་འགྲོ་པ་ཡིན། ་་་་་་་་་་',
    v2: '智爲先導身、語、意業',
    v3: '隨智慧身、口、意業',
    v5: '-',
    v4: '身所行，智慧在上頭；口所言，智慧在上頭；心所念，智慧在上頭',
    other: null,
  },
  {
    no: '4.1',
    v1: 'རིགས་ཕུན་སུམ་ཚོགས་པ་ཡིན།་་་་་་་་་',
    v2: '生處具足',
    v3: '生處成就',
    v5: '出生端正',
    v4: '生時端正',
    other: null,
  },
  {
    no: '4.2',
    v1: 'རུས་ཕུན་སུམ་ཚོགས་པ་ཡིན།་་་་་་་་',
    v2: '種族具足',
    v3: '姓成就',
    v5: '族姓尊貴',
    v4: '生時種類中好',
    other: null,
  },
  {
    no: '4.3',
    v1: 'རྒྱུད་ཕུན་སུམ་ཚོགས་པ་ཡིན།་་་་་་་་',
    v2: '家具足',
    v3: '家成就',
    v5: '知重佛法',
    v4: '生時於尊貴家',
    other: null,
  },
  {
    no: '4.4',
    v1: 'གཟུགས་ཕུན་སུམ་ཚོགས་པ་ཡིན།་་་་་་་་',
    v2: '色具足',
    v3: '色成就',
    v5: '色無比',
    v4: '生時面色好',
    other: null,
  },
  {
    no: '4.5',
    v1: 'མཚན་ཕུན་སུམ་ཚོགས་པ་ཡིན།་་་་་་་་',
    v2: '相具足',
    v3: '相成就',
    v5: '相無比',
    v4: '生時善相與衆異',
    other: null,
  },
  {
    no: '4.6',
    v1: 'དྲན་པ་ཕུན་སུམ་ཚོགས་པ་ཡིན།་་་་་་་་',
    v2: '念具足',
    v3: '念成就',
    v5: '自守志强',
    v4: '意所念皆强，多所護持不忘',
    other: null,
  },
  {
    no: '4.7',
    v1: 'བློ་གྲོས་ཕུན་སུམ་ཚོགས་པ་ཡིན།་་་་་་་་',
    v2: '慧具足',
    v3: '智慧成就',
    v5: '-',
    v4: '生時智慧',
    other: null,
  },
  {
    no: '4.8',
    v1: 'རྟོགས་པ་ཕུན་སུམ་ཚོགས་པ་ཡིན།་་་་་་་་',
    v2: '行具足',
    v3: '趣成就',
    v5: '常行四等',
    v4: '-',
    other: null,
  },
  {
    no: '4.9',
    v1: 'དགའ་བ་ཕུན་སུམ་ཚོགས་པ་ཡིན།་་་་་་་་',
    v2: '（無畏具足）',
    v3: '（無畏具足）',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '4.10',
    v1: 'བློ་ཕུན་སུམ་ཚོགས་པ་ཡིན།་་་་་་་་',
    v2: '覺悟具足',
    v3: '覺悟成就',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '5.1',
    v1: 'བློ་གྲོས་མཆོག་ཏུ་གྱུར་པ་ཡིན།་་་་་་་་',
    v2: '勝慧',
    v3: '勝智慧',
    v5: '-',
    v4: '猛中勇',
    other: null,
  },
  {
    no: '5.2',
    v1: 'བློ་གྲོས་དམ་པར་གྱུར་པ་ཡིན།་་་་་་་་',
    v2: '第一慧',
    v3: '第一智慧',
    v5: '-',
    v4: '猛中尊',
    other: null,
  },
  {
    no: '5.3',
    v1: 'བློ་གྲོས་རབ་ཏུ་གྱུར་པ་ཡིན།་་་་་་་་',
    v2: '最上慧',
    v3: '最上智慧',
    v5: '-',
    v4: '猛中貴',
    other: null,
  },
  {
    no: '5.4',
    v1: 'བློ་གྲོས་ཚད་མེད་པ་ཡིན།་་་་་་་་',
    v2: '無量慧',
    v3: '不可量智慧',
    v5: '-',
    v4: '所議爲無有能計量者',
    other: null,
  },
  {
    no: '5.5',
    v1: 'བློ་གྲོས་གྲངས་མེད་པ་ཡིན།་་་་་་་་',
    v2: '無數慧',
    v3: '不可數智慧',
    v5: '-',
    v4: '所議無有央數',
    other: null,
  },
  {
    no: '5.6',
    v1: 'བློ་གྲོས་བསམ་གྱིས་མི་ཁྱབ་པ་ཡིན།་་་་་་་་',
    v2: '不思議慧',
    v3: '不可思議智慧',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '5.7',
    v1: 'བློ་གྲོས་མཚུངས་པ་མེད་པ་ཡིན།་་་་་་་་',
    v2: '無與等慧',
    v3: '-',
    v5: '-',
    v4: '所議爲無有能勝者',
    other: null,
  },
  {
    no: '5.8',
    v1: 'བློ་གྲོས་བརྗོད་དུ་མེད་པ་ཡིན།་་་་་་་་',
    v2: '不可說慧',
    v3: '不可說智慧',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '5.9',
    v1: 'བློ་གྲོས་གཞལ་དུ་མེད་པ་ཡིན།་་་་་་་་',
    v2: '不可量慧',
    v3: '不可稱智慧',
    v5: '-',
    v4: '所議爲不可計',
    other: null,
  },
  {
    no: '6.1',
    v1: 'རྒྱུའི་སྟོབས་ཅན་ཡིན།་་་་་་་',
    v2: '得因力',
    v3: '因力具足',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '6.2',
    v1: 'བསམ་པའི་སྟོབས་ཅན་་་་་་་་',
    v2: '得欲力',
    v3: '意力具足',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '6.3',
    v1: 'སྦྱོར་བའི་སྟོབས་ཅན་ཡིན།་་་་་་་',
    v2: '得方便力',
    v3: '方便力具足',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '6.4',
    v1: 'རྐྱེན་གྱི་སྟོབས་ཅན་ཡིན།་་་་་་་',
    v2: '得緣力',
    v3: '緣力具足',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '6.5',
    v1: 'དམིགས་པའི་སྟོབས་ཅན་ཡིན།་་་་་་་',
    v2: '得所緣力',
    v3: '境界力具足',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '6.6',
    v1: 'དབང་པོའི་སྟོབས་ཅན་ཡིན།་་་་་་་',
    v2: '得根力',
    v3: '根力具足',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '6.7',
    v1: 'རྣམ་པར་ལྟ་བའི་སྟོབས་ཅན་ཡིན།་་་་་་་',
    v2: '得觀察力',
    v3: '-',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '6.8',
    v1: 'ཞི་གནས་ཀྱི་སྟོབས་ཅན་ཡིན།་་་་་་་',
    v2: '得奢摩他力',
    v3: '止力具足',
    v5: '降心正意',
    v4: '一心降意',
    other: null,
  },
  {
    no: '6.9',
    v1: 'ལྷག་མཐོང་གི་སྟོབས་ཅན་ཡིན།་་་་་་་',
    v2: '得毘鉢舍那力',
    v3: '觀力具足',
    v5: '攝念入禪',
    v4: '佪念入禪',
    other: null,
  },
  {
    no: '6.10',
    v1: 'ངེས་པར་རྟོག་པའི་སྟོབས་ཅན་ཡིན།་་་་་་་',
    v2: '得思惟力',
    v3: '定力具足',
    v5: '-',
    v4: '思惟明曉',
    other: null,
  },
  {
    no: '7.1',
    v1: 'ཕུང་པོ་ལ་མཁས་པ་ཡིན།་་་་་་་',
    v2: '薀善巧',
    v3: '善知陰',
    v5: '出入五陰',
    v4: '出入五音中',
    other: null,
  },
  {
    no: '7.2',
    v1: 'ཁམས་ལ་མཁས་པ་ཡིན།་་་་་་་',
    v2: '界善巧',
    v3: '(善知)...界',
    v5: '(出入)四大',
    v4: '入於四事中',
    other: null,
  },
  {
    no: '7.3',
    v1: 'སྐྱེ་མཆེད་ལ་མཁས་པ་ཡིན།་་་་་་་',
    v2: '處善巧',
    v3: '(善知)...入',
    v5: '(出入)六入',
    v4: '-',
    other: null,
  },
  {
    no: '7.4',
    v1: 'རྟེན་ཅིང་འབྲེལ་པར་འབྱུང་བ་ལ་མཁས་པ་ཡིན།་་་་་་་',
    v2: '緣起善巧',
    v3: '(善知)....緣起法',
    v5: '(出入)....十二緣起',
    v4: '入於十二事中',
    other: null,
  },
  {
    no: '7.5',
    v1: 'འདོད་པའི་ཁམས་ལ་མཁས་པ་ཡིན།་་་་་་་',
    v2: '欲界善巧',
    v3: '(善知)....欲',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '7.6',
    v1: 'གཟུགས་ཀྱི་ཁམས་ལ་མཁས་པ་ཡིན།་་་་་་་',
    v2: '色界善巧',
    v3: '(善知)....色',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '7.7',
    v1: 'གཟུགས་མེད་པའི་ཁམས་ལ་མཁས་པ་ཡིན།་་་་་་་',
    v2: '無色界善巧',
    v3: '(善知)....無色界',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '7.8',
    v1: 'འདས་པ་ལ་མཁས་པ་ཡིན།་་་་་་་',
    v2: '過去善巧',
    v3: '善知過去',
    v5: '-',
    v4: '過去所出生福祐功德中',
    other: null,
  },
  {
    no: '7.9',
    v1: 'མ་འོངས་པ་ལ་མཁས་པ་ཡིན།་་་་་་་',
    v2: '未來善巧',
    v3: '善知未來',
    v5: '-',
    v4: '當來所出生福祐功德中',
    other: null,
  },
  {
    no: '7.10',
    v1: 'ད་ལྟར་བྱུང་བ་ལ་མཁས་པ་ཡིན།་་་་་་་',
    v2: '現在善巧',
    v3: '善知現在',
    v5: '-',
    v4: '今現在所出生福祐功德中',
    other: null,
  },
  {
    no: '8.1',
    v1: 'དྲན་པ་ཡང་དག་བྱང་ཆུབ་ཀྱི་ཡན་ལག་ལ་མཁས་པ་ཡིན།་་་་་་་',
    v2: '善修習念覺分',
    v3: '修七覺意',
    v5: '七覺不閡',
    v4: '入於七覺意中',
    other: null,
  },
  {
    no: '8.2',
    v1: 'ཆོས་རྣམ་པར་འབྱེད་པ་ཡང་དག་བྱང་ཆུབ་ཀྱི་ཡན་ལག་ལ་མཁས་པ་ཡིན།་་་་་་་',
    v2: '善修習擇法覺分',
    v3: '修七覺意',
    v5: '七覺不閡',
    v4: '入於七覺意中',
    other: null,
  },
  {
    no: '8.3',
    v1: 'བརྩོན་འགྲུས་ཡང་དག་བྱང་ཆུབ་ཀྱི་ཡན་ལག་ལ་མཁས་པ་ཡིན།་་་་་་་',
    v2: '善修習精進覺分',
    v3: '修七覺意',
    v5: '七覺不閡',
    v4: '入於七覺意中',
    other: null,
  },
  {
    no: '8.4',
    v1: 'དགའ་བ་ཡང་དག་བྱང་ཆུབ་ཀྱི་ཡན་ལག་ལ་མཁས་པ་ཡིན།་་་་་་་',
    v2: '善修習喜覺分',
    v3: '修七覺意',
    v5: '七覺不閡',
    v4: '入於七覺意中',
    other: null,
  },
  {
    no: '8.5',
    v1: 'ཤིན་ཏུ་སྦྱངས་པ་ཡང་དག་བྱང་ཆུབ་ཀྱི་ཡན་ལག་ལ་མཁས་པ་ཡིན།་་་་་་་',
    v2: '善修習猗覺分',
    v3: '修七覺意',
    v5: '七覺不閡',
    v4: '入於七覺意中',
    other: null,
  },
  {
    no: '8.6',
    v1: 'ཏིང་ངེ་འཛིན་ཡང་དག་བྱང་ཆུབ་ཀྱི་ཡན་ལག་ལ་མཁས་པ་ཡིན།་་་་་་་',
    v2: '善修習定覺分',
    v3: '修七覺意',
    v5: '七覺不閡',
    v4: '入於七覺意中',
    other: null,
  },
  {
    no: '8.7',
    v1: 'བཏང་སྙོམས་ཡང་དག་བྱང་ཆུབ་ཀྱི་ཡན་ལག་ལ་མཁས་པ་ཡིན།་་་་་་་',
    v2: '善修習捨覺分',
    v3: '修七覺意',
    v5: '七覺不閡',
    v4: '入於七覺意中',
    other: null,
  },
  {
    no: '8.8',
    v1: 'སྟོང་པ་ཉིད་ཡོངས་སུ་བསྒོམས་པ་་་་་་་',
    v2: '(善修習)空',
    v3: '(修)空',
    v5: '曉空.....(之法)',
    v4: '入於虛空',
    other: null,
  },
  {
    no: '8.9',
    v1: 'མཚན་མ་མེད་པ་ཡོངས་སུ་བསྒོམས་པ་་་་་་་',
    v2: '善修習無相',
    v3: '修無相',
    v5: '曉無想之法',
    v4: '（入於無常）',
    other: null,
  },
  {
    no: '8.10',
    v1: 'སྨོན་པ་མེད་པ་ཡོངས་སུ་བསྒོམས་པ་་་་་་་',
    v2: '善修習無願',
    v3: '修無作',
    v5: '曉不願之法',
    v4: '（入於無所罣礙中）',
    other: null,
  },
  {
    no: '9.1',
    v1: 'སྦྱིན་པའི་ཕ་རོལ་ཏུ་ཕྱིན་པ་་་་་་་',
    v2: '檀波羅蜜',
    v3: '檀波羅蜜',
    v5: '習衆德本_ _諸度無極',
    v4: '入於六波羅蜜經中',
    other: null,
  },
  {
    no: '9.2',
    v1: 'ཚུལ་ཁྲིམས་ཀྱི་ཕ་རོལ་ཏུ་ཕྱིན་པ་་་་་་་',
    v2: '尸波羅蜜',
    v3: '尸羅波羅蜜',
    v5: '習衆德本_ _諸度無極',
    v4: '入於六波羅蜜經中',
    other: null,
  },
  {
    no: '9.3',
    v1: 'བཟོད་པའི་ཕ་རོལ་ཏུ་ཕྱིན་པ་་་་་་་',
    v2: '羼提波羅蜜',
    v3: '羼提波羅蜜',
    v5: '習衆德本_ _諸度無極',
    v4: '入於六波羅蜜經中',
    other: null,
  },
  {
    no: '9.4',
    v1: 'བརྩོན་འགྲུས་ཀྱི་ཕ་རོལ་ཏུ་ཕྱིན་པ་་་་་་་',
    v2: '毘梨耶波羅蜜',
    v3: '毘梨耶波羅蜜',
    v5: '習衆德本_ _諸度無極',
    v4: '入於六波羅蜜經中',
    other: null,
  },
  {
    no: '9.5',
    v1: 'བསམ་གཏན་གྱི་ཕ་རོལ་ཏུ་ཕྱིན་པ་་་་་་་',
    v2: '禪那波羅蜜',
    v3: '禪那波羅蜜',
    v5: '習衆德本_ _諸度無極',
    v4: '入於六波羅蜜經中',
    other: null,
  },
  {
    no: '9.6',
    v1: 'ཤེས་རབ་ཀྱི་ཕ་རོལ་ཏུ་ཕྱིན་པ་་་་་་་',
    v2: '般若波羅蜜',
    v3: '般若波羅蜜',
    v5: '習衆德本_ _諸度無極',
    v4: '入於六波羅蜜經中',
    other: null,
  },
  {
    no: '9.7',
    v1: 'བྱམས་པའི་ཕ་རོལ་ཏུ་ཕྱིན་པ་་་་་་་',
    v2: '(圓滿)慈',
    v3: '慈',
    v5: '所爲無量',
    v4: '(悉具足)....慈愛',
    other: null,
  },
  {
    no: '9.8',
    v1: 'སྙིང་རྗེའི་ཕ་རོལ་ཏུ་ཕྱིན་པ་་་་་་་',
    v2: '(圓滿)悲',
    v3: '悲',
    v5: '所爲無量',
    v4: '(悉具足)....愍傷',
    other: null,
  },
  {
    no: '9.9',
    v1: 'དགའ་བའི་ཕ་རོལ་ཏུ་ཕྱིན་པ་་་་་་་',
    v2: '喜',
    v3: '喜',
    v5: '所爲無量',
    v4: '(悉具足)....念善',
    other: null,
  },
  {
    no: '9.10',
    v1: 'བཏང་སྙོམས་ཀྱི་ཕ་རོལ་ཏུ་ཕྱིན་པ་་་་་་་',
    v2: '捨',
    v3: '捨',
    v5: '所爲無量',
    v4: '(悉具足)....無所憎愛',
    other: null,
  },
  {
    no: '10',
    v1: '',
    v2: '',
    v3: '',
    v5: '',
    v4: '',
    other: '在《本業》經文中的「十力智」與,《求佛》經文中的「十種力慧」於,《藏譯》,《八十》,《六十》經文中分別闡述如下：<br/>《藏譯華嚴·淨行品》<br/>༡༽གནས་དང་གནས་མ་ཡིན་པ་ཤེས་པར་བྱ་བ་ཁོང་དུ་ཆུད་པ།༢༽འདས་པ་དང་མ་འོངས་པ་དང་ད་ལྟར་བྱུང་བའི་ལས་ཀྱི་རྣམ་པར་སྨིན་པ་ཤེས་པར་བྱ་བ་ཁོང་དུ་ཆུད་པ།༣༽དབང་པོ་དང་བརྩོན་འགྲུས་ཐ་དད་པ་ཡོངས་སུ་རྫོགས་པར་བྱ་བ་གཅིག་ནས་གཅིག་ཏུ་བརྒྱུད་པ་ཁོང་དུ་ཆུད་པ།༤༽ཁམས་སྣ་ཚོགས་དང་ཁམས་དུ་མ་ཤེས་པར་བྱ་བ་ཁོང་དུ་ཆུད་པ།༥༽མོས་པ་སྣ་ཚོགས་དང་མོས་པ་དུ་མ་ཤེས་པར་བྱ་བ་ཁོང་དུ་ཆུད་པ།༦༽ཀུན་ཏུ་འགྲོ་བའི་ལམ་ཤེས་པར་བྱ་བ་ཁོང་དུ་ཆུད་པ།༧༽བསམ་གཏན་དང་རྣམ་པར་ཐར་པ་དང་ཏིང་ངེ་འཛིན་དང་སྙོམས་པར་འཇུག་པ་དང་ཀུན་ནས་ཉོན་མོངས་པ་དང་རྣམ་པར་བྱང་བ་དང་ལྡང་བ་ཤེས་པར་བྱ་བ་ཁོང་དུ་ཆུད་པ།༨༽སྒྲིབ་པ་མེད་པའི་རྗེས་སུ་དྲན་པ་ཤེས་པར་བྱ་བ་ཁོང་དུ་ཆུད་པ།༩༽ལྷའི་མིག་ཆགས་པ་མེད་པར་ཤེས་པར་བྱ་བ་ཁོང་དུ་ཆུད་པ།༡༠༽བག་ཆགས་ཀྱི་མཚམས་སྦྱོར་བ་ཡང་དག་པར་གཅད་པ་ཤེས་པར་བྱ་བ་ཁོང་དུ་ཆུད་པ།<br/>《八十華嚴·淨行品》<br/>1.處、非處智力2.過、未、現在業報智力3.根勝劣智力4.種種界智力5.種種解智力6.一切至處道智力7.禪、解脫、三昧、染、淨智力8.宿住念智力9.無障礙天眼智力10.斷諸習智力<br/>《六十華嚴·淨行品》<br/>1.是處、非處智力2.過去、未來、現在業報智力3.種種諸根智力4.種種性智力5.種種欲智力6.一切至處道智力7.禪定、解脫、三昧、垢、淨智力8.宿命無礙智力9.天眼無礙智力10.斷一切煩惱習氣智力',
  },
  {
    no: '16',
    v1: 'ལྷ་དང་མི་རྣམས་ཀྱི་དོན་དང་ཕན་པ་དང་བདེ་བ་དང་བདེ་བར་རྣམ་པར་གཟུད་པ་་་་་',
    v2: '利樂天、人',
    v3: '惠利一切，安樂天、人',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '17.1',
    v1: 'སེམས་ཀྱི་ལས་ཡིད་ལ་བྱེད་པའི་སྦྱོར་བ་གང་དང་ལྡན་པ་་་་་',
    v2: '善用其心',
    v3: '（成就身、口、意業）',
    v5: '（正身，言、念相應，口習經典，心思可行，改往修來，不釋道意，積德累善，施恩不倦）',
    v4: '（有身所行，有口所言，有心所念，有意所念道）',
    other: null,
  },
  {
    no: '17.2',
    v1: 'ཡོན་ཏན་གྱི་ཁྱད་པར་འདི་དག་ཐམས་ཅད་འཐོབ་པར་འགྱུར་བ་་་་་',
    v2: '獲一切勝妙功德',
    v3: '得一切勝妙功德',
    v5: '-',
    v4: '諸所施行功德，悉可得，未曾增減',
    other: null,
  },
  {
    no: '17.3',
    v1: 'སངས་རྒྱས་ཀྱི་ཆོས་ཐམས་ཅད་ལ་ཐོགས་པ་མེད་པའི་ལུས་སུ་འགྱུར་བ་་་་',
    v2: '於諸佛法，心無所礙',
    v3: '於佛正法，心無罣礙',
    v5: '如佛法教，無得增減',
    v4: '諸所說經悉諦受',
    other: null,
  },
  {
    no: '17.4',
    v1: 'སངས་རྒྱས་བཅོམ་ལྡན་འདས་འདས་པ་དང་མ་བྱོན་པ་དང་ད་ལྟར་བྱུང་བ་རྣམས་ཀྱི་ལམ་དུ་འཇུག་པ་་་་',
    v2: '住去、來、今諸佛之道',
    v3: '去、來、今佛所轉法輪，能隨順轉',
    v5: '-',
    v4: '佛經時，過去、當來、今現在佛，悉受得之，皆從是起成',
    other: null,
  },
  {
    no: '17.5',
    v1: 'སེམས་ཅན་ཐམས་ཅད་ཡོངས་སུ་མི་གཏོང་པའི་སེམས་ཀྱང་དེ་དག་ལ་ཉེ་བར་གནས་པ་་་་',
    v2: '隨衆生住，恒不捨離',
    v3: '不捨衆生',
    v5: '念安世間',
    v4: '使世間人民悉安隱',
    other: null,
  },
  {
    no: '17.6',
    v1: 'ཆོས་ཐམས་ཅད་ཇི་ལྟ་བ་བཞིན་དུ་རྣམ་པར་ལྟ་བ་ཡང་དེ་དག་ལ་ཉེ་བར་གནས་པ་་་་',
    v2: '如諸法相，悉能通達',
    v3: '明達實相',
    v5: '（必諦受學，如佛法教，無得增減）',
    v4: '（諸所說經，悉諦受）',
    other: null,
  },
  {
    no: '17.7',
    v1: 'མི་དགེ་བའི་ཆོས་ཐམས་ཅད་སྤངས་པར་འགྱུར་བ་་་་',
    v2: '斷一切惡',
    v3: '斷一切惡',
    v5: '-',
    v4: '諸所有宿命惡，悉消盡',
    other: null,
  },
  {
    no: '17.8',
    v1: 'དགེ་བའི་ཆོས་ཐམས་ཅད་དང་ལྡན་པར་འགྱུར་བ་་་་',
    v2: '具足衆善',
    v3: '具足衆善',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '19',
    v1: 'རང་བཞིན་ཤེས་པ་དང་ལྡན་པས་ཁྱིམ་གྱི་ཐིབས་པོས་ཟིལ་གྱིས་མི་ནོན་པ་་་་',
    v2: '知家性空　免其逼迫',
    v3: '捨離家難　入空法中',
    v5: '貪欲意解　入空法',
    v4: '莫爲愛欲所拘繫，悉入虛空法中',
    other: null,
  },
  {
    no: '20',
    v1: 'སྐྱེ་བོ་ཐམས་ཅད་ཡོངས་སུ་བསྐྱབ་པའི་ཕྱིར་སངས་རྒྱས་དང་འགྲོགས་པ་་་་',
    v2: '善事於佛　護養一切',
    v3: '一切護養　永得大安',
    v5: '一切護視　使得佛道',
    v4: '早得佛道，以當度脫十方天下人',
    other: null,
  },
  {
    no: '21',
    v1: 'སྲེད་པ་དང་ཤིན་ཏུ་བྲལ་བས་དགའ་བ་དང་མི་དགའ་བ་དང་རྣམ་པར་བྲལ་བ་་་་',
    v2: '怨親平等　永離貪著',
    v3: '令出愛獄　無戀慕心',
    v5: '令出愛獄　無戀慕心',
    v4: '諸有愛欲，悉消去',
    other: null,
  },
  {
    no: '22',
    v1: 'ཡོན་ཏན་གྱི་ཕ་རོལ་ཏུ་ཕྱིན་པས་འདོད་པའི་གསལ་ཤིང་རྣམ་པར་སེལ་བ་་་་',
    v2: '拔除欲箭　究竟安隱',
    v3: '捨離貪惑　功德具足',
    v5: '皆入淸淨　心無所著',
    v4: '脫於愛欲中，得道極過度',
    other: null,
  },
  {
    no: '23',
    v1: 'གར་མཁན་གྱིས་ཚོན་ལྟ་བུར་མཐོང་བ་དང་ལྡན་ཞིང་ཆོས་ཡང་དག་པར་འགྲོ་བའི་བརྗོད་པ་རབ་ཏུ་ཐོབ་པ་་་་',
    v2: '以法自娛　了妓非實',
    v3: '悉得法樂　見法如幻',
    v5: '悉得法樂　歡喜之忍',
    v4: '聽受諸經，悉聞得，如是作音樂時，欲聽聞',
    other: null,
  },
  {
    no: '24.1',
    v1: 'ཆུང་མའི་འཁོར་གྱི་ནང་ན་འདུག་པ་་་་',
    v2: '在宮室',
    v3: '在房室',
    v5: '身在房室',
    v4: '與妻子恩愛',
    other: null,
  },
  {
    no: '24.2',
    v1: 'འདོད་པའི་གསལ་ཤིང་དང་བྲལ་ཞིང་འཕགས་པའི་སར་ཆུད་པ་་་་',
    v2: '入於聖地　永除穢欲',
    v3: '入賢聖地　永離欲穢',
    v5: '覺知惡露　無有更樂',
    v4: '早脫去。於婬泆惡露，悉棄捐，令覺知入虛空中',
    other: null,
  },
  {
    no: '25',
    v1: 'སྲིད་པར་འབྱུང་བ་འཇིག་པའི་ཕ་རོལ་ཏུ་ཕྱིན་པས་ཁུར་བོར་བ་་་',
    v2: '捨諸僞飾　到真實處',
    v3: '捨去重擔　度有無岸',
    v5: '解去重擔　諸綺可意',
    v4: '脫於重擔去，悉得止休息',
    other: null,
  },
  {
    no: '26',
    v1: 'ཆོས་ཐམས་ཅད་ཀྱི་ཁྱད་པར་ཁོང་དུ་ཆུད་ཅིང་ཆོས་ཀྱི་ཁང་སྟེང་སུ་ཕྱིན་པ་་་',
    v2: '昇正法樓　徹見一切',
    v3: '昇佛法堂　得微妙法',
    v5: '皆昇法堂　受佛諸經',
    v4: '上佛經講堂上，悉受諸經，無有與等者',
    other: null,
  },
  {
    no: '27',
    v1: 'བདག་གིར་བྱ་བ་མེད་དེ། ཡོངས་སུ་འཛིན་པའི་སེམས་མེད་ཅིང་བདག་གི་ཐམས་ཅད་ཡོངས་སུ་གཏོང་བ་་་',
    v2: '一切能捨　心無愛著',
    v3: '悉捨一切　心無貪著',
    v5: '興福救之　莫墮慳貪',
    v4: '諸所有，但欲施與人，無有貪愛者',
    other: null,
  },
  {
    no: '28',
    v1: 'ཐམས་ཅད་མཁྱེན་པ་ཉིད་ཀྱི་མཐར་ཕྱིན་ཏེ། འདུ་བ་དང་ཤིན་ཏུ་བྲལ་བ་་་་་་་',
    v2: '捨衆聚法　成一切智',
    v3: '究竟解脫　到如來會',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '29',
    v1: 'གནས་མེད་པ་ལ་སྤྱོད་ཅིང་། གང་དུ་དགའ་བར་འདོང་བ་་་་་་་',
    v2: '隨意自在　所行無礙',
    v3: '隨意自在　無所罣礙',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '30',
    v1: 'སེམས་བཅིངས་པ་དང་གྲོལ་བ་མེད་ཅིང་ཆགས་པ་མེད་དེ་མི་དགོས་པ་དང་བྲལ་བ་་་་་་་',
    v2: '出家無礙　心得解脫',
    v3: '棄捨世業　心無所著',
    v5: '疾得解脫　無所拘綴',
    v4: '早得脫解，無所復拘著',
    other: null,
  },
  {
    no: '31',
    v1: 'འགལ་བ་མེད་པའི་ཆོས་དང་ལྡན་ཞིང་མཐུན་པར་འགྲོ་བ་མང་པོ་དང་ལྡན་པ་་་་་་་',
    v2: '演說種種　無乖諍法',
    v3: '一切和合　心無限礙',
    v5: '近佛行法　無復罣礙',
    v4: '但念佛，悉入諸經中，無所復罣礙',
    other: null,
  },
  {
    no: '32',
    v1: 'ཆོས་ལ་རྩོམ་ཞིང་ཆོ་ག་ལ་མཁས་པ་་་་་་་',
    v2: '巧事師長　習行善法',
    v3: '開方便門　入深法要',
    v5: '開達入正　悉得如願',
    v4: '心所念善，無有不得者，悉入正經中',
    other: null,
  },
  {
    no: '33',
    v1: 'བར་ཆད་མེད་ཅིང་ཕྱིར་མི་ལྡོག་པའི་ཆོས་ཅན་་་་་་་',
    v2: '得不退法　心無障礙',
    v3: '得不退轉　心無障礙',
    v5: '得成就志　學不中悔',
    v4: '所至到，悉令得成就，莫復中悔止',
    other: null,
  },
  {
    no: '34',
    v1: 'སྡིག་པ་ལ་བརྩོན་པ་སྤངས་ཏེ། དགེ་བའི་རྩ་བ་ཤིན་ཏུ་སྦྱངས་པ་་་་་་་',
    v2: '勤修善根　捨諸罪軛',
    v3: '解道修德   無復懈怠',
    v5: '解道修德　無有懈怠',
    v4: '極照明於功德中，莫令有懈怠',
    other: null,
  },
  {
    no: '35',
    v1: 'ཤིན་ཏུ་མཉམ་པར་བཞག་ཅིང་ཉོན་མོངས་པ་མེད་པ་་་་་་་',
    v2: '永離煩惱　究竟寂滅',
    v3: '斷除煩惱　究竟寂滅',
    v5: '除捐飾好　無有衆勞',
    v4: '垢濁，悉除去，莫復與共會',
    other: null,
  },
  {
    no: '36',
    v1: 'དྲང་སྲོང་ཆེན་པོའི་སེམས་དང་ལྡན་ཞིང་རྙོག་པ་མེད་པ་་་་་་་',
    v2: '心無所染　具大仙道',
    v3: '捨離三毒　心得歡喜',
    v5: '被法服行　心無沾汙',
    v4: '持心如佛',
    other: null,
  },
  {
    no: '37',
    v1: 'སྐྱེ་བོ་ཐམས་ཅད་ཡོངས་སུ་སྐྱོང་བའི་ཕྱིར། དེ་བཞིན་གཤེགས་པའི་རབ་ཏུ་འབྱུང་བར་རབ་ཏུ་བྱུང་བ་་་་་་་',
    v2: '同佛出家　救護一切',
    v3: '如佛出家　開導一切',
    v5: '受行佛意　開導天下',
    v4: '作沙門時，令如佛，悉度十方天下人',
    other: null,
  },
  {
    no: '38',
    v1: 'དགེ་བ་ལ་མོས་པ་མངོན་པར་སྐྱེས་པས།སངས་རྒྱས་ཀྱི་གདུང་མི་འཆད་པའི་དོན་དུ་བརྩོན་པ་་་་་་་',
    v2: '紹隆佛種　發無上意',
    v3: '體解大道　發無上意',
    v5: '體解大道　發無上意',
    v4: '無不歡樂於佛法，悉生極好處',
    other: null,
  },
  {
    no: '39',
    v1: 'ཆོས་ཀྱི་གཏེར་རབ་ཏུ་ཐོབ་པ་་་་་་་',
    v2: '深入經藏',
    v3: '深入經藏',
    v5: '深入經藏',
    v4: '無不得深經藏',
    other: null,
  },
  {
    no: '40',
    v1: 'ཆགས་པའི་གནས་དང་བྲལ་ཞིང་དགེ་འདུན་ཡོངས་སུ་སྡུད་པ་་་་་་་',
    v2: '統理大衆　一切無礙',
    v3: '統理大衆　一切無礙',
    v5: '依附聖衆　從正得度',
    v4: '無不得依度，如比丘僧有所依度，樂於佛道德',
    other: null,
  },
  {
    no: '41',
    v1: 'ཚུལ་བཟང་པོ་ལ་ཡང་དག་པར་སྤྱོད་ཅིང་བསླབ་པ་ཐམས་ཅད་ལ་ཤིན་ཏུ་སློབ་པ་་་་་་་',
    v2: '善學於戒　不作衆惡',
    v3: '具足修習　學一切戒',
    v5: '皆奉法律　不犯法教',
    v4: '護持禁戒，莫令犯如法',
    other: null,
  },
  {
    no: '42',
    v1: 'ལོག་པ་མ་ཡིན་པའི་ལས་ལ་སྤྱོད་ཅིང་ཚུལ་དང་སྤྱོད་ཡུལ་ཕུན་སུམ་ཚོགས་པ་་་་་་་',
    v2: '具足威儀　所行真實',
    v3: '具足道戒　修如實業',
    v5: '承佛聖教　所受不忘',
    v4: '所作，悉爲狎習，如所教法，持不失',
    other: null,
  },
  {
    no: '43',
    v1: 'གནས་མེད་པ་ལ་ཡང་དག་པར་གཞོལ་ཞིང་མི་སྐྱེ་བའི་ཡེ་ཤེས་ཀྱི་ཕ་རོལ་ཏུ་ཕྱིན་པ་་་་་་་',
    v2: '入無生智　到無依處',
    v3: '得無生智　到於彼岸',
    v5: '令如禪意　思惟解脫',
    v4: '念所知禪極過度，無所一罣礙',
    other: null,
  },
  {
    no: '44',
    v1: 'ཆོས་ཐམས་ཅད་ཀྱི་ཁྱད་པར་གྱི་ཕ་རོལ་ཏུ་ཕྱིན་སྟེ་ཐབས་མཁས་པའི་ཕ་རོལ་ཏུ་ཕྱིན་པ་་་་་་་',
    v2: '具諸方便　得最勝法',
    v3: '得勝妙法　成就方便',
    v5: '得道方便　慧度無極',
    v4: '還漚和拘舍羅波羅蜜，悉得經',
    other: null,
  },
  {
    no: '45',
    v1: 'མི་འཕྲོགས་པའི་ཆོས་ཅན་དུ་གྱུར་ཏེ་བླ་ན་མེད་པའི་གནས་ལ་རྣམ་པར་སྤྱོད་པ་་་་་་་',
    v2: '昇無上堂　安住不動',
    v3: '昇無上堂　得不退法',
    v5: '安隱寂寞　得止觀意',
    v4: '得度脫。所居止處，早如佛所止處。早逮得深經，衆阿羅漢、辟支佛所不能及',
    other: null,
  },
  {
    no: '46',
    v1: 'ཆོས་ཇི་ལྟ་བ་བཞིན་དུ་མཐོང་ཞིང་ལེགས་པར་བཀོད་པའི་ཆོས་ཅན་་་་་་་',
    v2: '開敷善法　見真實相',
    v3: '敷善法座　見真實相',
    v5: '入大乘道　濟安天下',
    v4: '早入至深經中，悉視十方人虛空',
    other: null,
  },
  {
    no: '47',
    v1: 'མི་གནས་པའི་སེམས་ཀྱིས་སྙིང་པོ་བྱང་ཆུབ་ལ་འདུག་པ་་་་་་་',
    v2: '坐菩提座　心無所著',
    v3: '坐佛道樹　心無所倚',
    v5: '坐佛道樹　心無所猗',
    v4: '坐安，如佛坐於師子座上時，莫令心有所著',
    other: null,
  },
  {
    no: '48',
    v1: 'མི་གཡོ་བའི་ས་ལ་དགེ་བའི་རྩ་བ་ཤིན་ཏུ་བརྟན་པ་་་་་་་',
    v2: '善根堅固　得不動地',
    v3: '善根堅固　得不動地',
    v5: '-',
    v4: '入正功德中，無令有狐疑，增減佛經中',
    other: null,
  },
  {
    no: '49',
    v1: 'མ་ལུས་པའི་མཐར་ཐུག་པ་ལ་བརྩོན་ཞིང་ཞི་བ་དང་། དུལ་བ་ལ་རབ་ཏུ་གཞོལ་བ་་་་་་་',
    v2: '以定伏心　究竟無餘',
    v3: '向三昧門　得究竟定',
    v5: '得捨家中　無世間念',
    v4: '喘息定成止足',
    other: null,
  },
  {
    no: '50',
    v1: 'ཤིན་ཏུ་ཉོན་མོངས་པ་མེད་པའི་ཆོས་ཅན་དུ་གྱུར་ཏེ། །ཆོས་ཡང་དག་པར་ཇི་ལྟ་བ་བཞིན་དུ་མཐོང་བ་་་་་་་',
    v2: '見如實理　永無乖諍',
    v3: '見法真實　無所罣礙',
    v5: '-',
    v4: '當作是念，見無常法',
    other: null,
  },
  {
    no: '51',
    v1: 'ཤིན་ཏུ་མཉམ་པར་བཞག་ཅིང་འདུ་བྱེད་ཐམས་ཅད་རང་བཞིན་གྱིས་འཇིག་པ་རྣམ་པར་མཐོང་བ་་་་་་་',
    v2: '觀諸行法　悉歸散滅',
    v3: '知諸行性　悉歸散滅',
    v5: '-',
    v4: '所見虛空法，無有不了知者',
    other: null,
  },
  {
    no: '52',
    v1: 'སེམས་རྣམ་པར་གྲོལ་བ་མི་འཁྲུགས་པ་ལ་རབ་ཏུ་གནས་པ་་་་་་་',
    v2: '心得解脫　安住不動',
    v3: '履踐聖跡　不動解脫',
    v5: '履踐佛跡　心不動搖',
    v4: '住安隱，不復動搖',
    other: null,
  },
  {
    no: '53',
    v1: 'ཁ་ན་མ་ཐོ་བ་མེད་པ་དང་ལྡན་པ་ཐོབ་སྟེ།འཁོར་བའི་རྒྱ་མཚོར་བྱིང་བ་ལས་འཐོན་པ་་་་་་་',
    v2: '出生死海　具衆善法',
    v3: '越度生死　善法滿足',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '54',
    v1: 'ངོ་ཚ་ཤེས་ཤིང་ཁྲེལ་ཡོད་པ་བླ་ན་མེད་པ་དང་ལྡན་ཞིང་དགེ་བའི་རྩ་བ་ཤིན་ཏུ་བརྟན་པ་་་་་་་',
    v2: '服諸善根　具足慚愧',
    v3: '服諸善根　每知慚愧',
    v5: '常知慚愧　攝意守道',
    v4: '撿持功德，悉愧於世間諸所有，早令得佛道',
    other: null,
  },
  {
    no: '55',
    v1: 'མི་འཁྲུགས་པའི་ཆོས་ཅན་དུ་གྱུར་ཏེ། དགེ་བའི་རྩ་བ་ཤིན་ཏུ་འབྲེལ་པ་་་་་་་',
    v2: '檢束善根　不令散失',
    v3: '自檢修道　不壞善法',
    v5: '束帶修善　志無解已',
    v4: '結諸功德，悉令堅',
    other: null,
  },
  {
    no: '56',
    v1: 'ཆོས་ཐམས་ཅད་ཀྱི་ཁྱད་པར་གྱི་ཕ་རོལ་ཏུ་ཕྱིན་པ་ཐོབ་སྟེ། གོང་ནས་གོང་དུ་དགེ་བའི་རྩ་བ་ཐོབ་པ་་་་་་་',
    v2: '獲勝善根　至法彼岸',
    v3: '得上善根　究竟勝法',
    v5: '恭敬畏愼　無有慢墮',
    v4: '重益，得諸功德，悉入諸經中，極過度去',
    other: null,
  },
  {
    no: '57',
    v1: 'མི་འཁྲུགས་པའི་ཆོས་ཅན་དུ་གྱུར་ཏེ་ཐབས་དམ་པས་མངོན་པར་བཀབ་པ་་་་་་་',
    v2: '入第一位　得不動法',
    v3: '大慈覆護　得不動法',
    v5: '服聖表式　敏於道行',
    v4: '常樂喜於佛經，未曾有離時',
    other: null,
  },
  {
    no: '58',
    v1: 'ཡོངས་སུ་དག་པའི་དངོས་པོ་འཐོབ་པའི་ཕྱིར་དམ་པའི་ཆོས་རྣམ་པར་དག་པ་ཐོབ་པ་་་་་་་',
    v2: '皆得妙法　究竟淸淨',
    v3: '心得正法　自然淸淨',
    v5: '學以法句　摘去諸垢',
    v4: '學諸經，悉淨潔得',
    other: null,
  },
  {
    no: '59',
    v1: 'ཉོན་མོངས་པ་ཤིན་ཏུ་བཅོམ་སྟེ། སེམས་དུལ་ཞིང་སེམས་རྣམ་པར་དག་པ་་་་་་་',
    v2: '其心調淨　噬諸煩惱',
    v3: '得調伏牙　噬諸煩惱',
    v5: '蕩滌情性　如淸淨住',
    v4: '諸垢濁，悉淨潔，去淸淨住',
    other: null,
  },
  {
    no: '60',
    v1: 'འདོད་ཆགས་དང་ཞེ་སྡང་དང་གཏི་མུག་སྤངས་ཏེ་སྡིག་པའི་ཆོས་ཐམས་ཅད་སྤངས་པ་་་་་་་',
    v2: '棄貪瞋癡　蠲除罪法',
    v3: '蠲除汙穢　無婬怒癡',
    v5: '蠲除汙穢　無婬怒癡',
    v4: '棄衆惡，斷絕婬泆、瞋恚、愚癡',
    other: null,
  },
  {
    no: '61',
    v1: 'འཇིག་རྟེན་ལས་འདས་པའི་ཆོས་ཐམས་ཅད་ལ་ཤིན་ཏུ་འབྱུང་བ་་་་་་་',
    v2: '出世法中　速疾而往',
    v3: '向無上道　得出世法',
    v5: '-',
    v4: '上佛經，悉淨潔',
    other: null,
  },
  {
    no: '62',
    v1: 'ཤིན་ཏུ་དག་པའི་དངོས་པོས་གཙང་ཞིང་དེས་པ་དང་ལྡན་པ་་་་་་་',
    v2: '淸淨調柔　畢竟無垢',
    v3: '具足淨忍　畢竟無垢',
    v5: '柔和軟弱　淸淨謹飾',
    v4: '無不謹勅、軟好、心淨潔',
    other: null,
  },
  {
    no: '63',
    v1: '་་་་་་་གཟུང་ཞིང་བཅང་པའི་ཕྱིར་བཀྲ་ཤིས་ཀྱི་ལག་པ་དང་ལྡན་པ་་་་་་་',
    v2: '得淸淨手　受持佛法',
    v3: '得上妙手　受持佛法',
    v5: '得柔淨掌　執受經道',
    v4: '軟好手，取諸經道法',
    other: null,
  },
  {
    no: '64',
    v1: 'ཤིན་ཏུ་ཉོན་མོངས་པ་དང་བྲལ་ཞིང་ཆོས་ཐམས་ཅད་ཀྱི་སྒོ་རྣམ་པར་དག་པ་ཐོབ་པ་་་་་་',
    v2: '得淨法門　永無垢染',
    v3: '向淨法門　究竟解脫',
    v5: '常向淸淨　心無瑕疵',
    v4: '入佛經道面門，莫令有瑕穢',
    other: null,
  },
  {
    no: '65',
    v1: 'མཆོད་སྦྱིན་བྱས་ཤིང་ལམ་སྟོན་པ་་་་་་',
    v2: '設大施會　示如實道',
    v3: '設淨施會　見道如實',
    v5: '依仗於法　分流德化',
    v4: '常作善，爲人所仰，常欲施與人，教人爲善法',
    other: null,
  },
  {
    no: '66',
    v1: 'འགྲོ་བ་ཐམས་ཅད་ཀྱིས་མཆོད་པར་འོས་ཤིང་སྣོད་དུ་གྱུར་་་་་་་',
    v2: '成就法器　受天人供',
    v3: '成就法器　受天人供',
    v5: '受而知施　修六重法',
    v4: '多所饋遺，悉受所供養，皆入於無底功德中',
    other: null,
  },
  {
    no: '67',
    v1: 'གནས་མེད་པར་གཞོལ་ཞིང་སངས་རྒྱས་ཀྱི་སྤྱོད་ཡུལ་ལ་མངོན་དུ་ཕྱོགས་པ་་་་་་',
    v2: '趣佛所行　入無依處',
    v3: '趣佛菩提　究竟解脫',
    v5: '向無上道　志不退轉',
    v4: '早得佛，莫復令還',
    other: null,
  },
  {
    no: '68',
    v1: 'ཕྱི་ན་མ་ལུས་པར་འགྲོ་ཞིང་སངས་རྒྱས་ཀྱི་ལམ་དུ་ཞུགས་པ་་་་་་',
    v2: '能行佛道　向無餘法',
    v3: '成就佛道　無餘所行',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '69',
    v1: 'ཤིན་ཏུ་རྣམ་པར་དག་པའི་ཆོས་སྒྲིབ་པ་མེད་པ་གྲུབ་པར་གྱུར་པས་ཆོས་ཀྱི་དབྱིངས་མཐའ་དང་དབུས་མེད་པ་ཁོང་དུ་ཆུད་པ་་་་་་',
    v2: '履淨法界　心無障礙',
    v3: '履淨法界　心無障礙',
    v5: '遊於無際　不中休息',
    v4: '入無底經中，悉深入經，淨潔身體，無所罣礙',
    other: null,
  },
  {
    no: '70',
    v1: 'ཤིན་ཏུ་ཞུམ་པ་མེད་དེ་ཁམས་གསུམ་ལས་གྱེན་དུ་འཕགས་པ་་་་་་',
    v2: '永出三界　心無怯弱',
    v3: '昇無上道　超出三界',
    v5: '樂昇上道　無所疑難',
    v4: '喜樂佛經，無有厭極時',
    other: null,
  },
  {
    no: '71',
    v1: 'དགེ་བའི་རྩ་བ་ཤིན་ཏུ་བརྟན་ཅིང་སངས་རྒྱས་ཐམས་ཅད་ལ་ཤིན་ཏུ་འདུད་པ་་་་་་',
    v2: '其心謙下　長佛善根',
    v3: '謙下柔軟　入佛深法',
    v5: '深入廣博　微妙法中',
    v4: '入佛大道中，悉貫諸智慧',
    other: null,
  },
  {
    no: '72',
    v1: 'ལྟ་བ་ཡོ་ཞིང་མི་དྲང་བ་དང་བྲལ་ཏེ་ལམ་ཉམ་ང་བ་ཡོངས་སུ་སྤངས་པ་་་་་་',
    v2: '捨不正道　永除惡見',
    v3: '棄捐惡道　滅除邪見',
    v5: '棄邪曲意　行不忮忮',
    v4: '莫有邪念，無令有惡口',
    other: null,
  },
  {
    no: '73',
    v1: 'གཡོ་མེད་ཅིང་སྒྱུ་མེད་དེ་སེམས་དྲང་པོ་དང་ལྡན་པ་་་་་་',
    v2: '其心正直　無諂無誑',
    v3: '得中正意　身口無曲',
    v5: '得中正意　言無諛諂',
    v4: '心念正道，無令有諛諂',
    other: null,
  },
  {
    no: '74',
    v1: 'ཤིན་ཏུ་རྡུལ་མེད་པའི་ཆོས་ཡང་དག་པར་ཐོབ་སྟེ་འདོད་ཆགས་པར་འགྱུར་བའི་ཆོས་ལས་རྣམ་པར་གྲོལ་བ་་་་་་',
    v2: '遠離塵坌　獲淸淨法',
    v3: '永離塵穢　畢竟淸淨',
    v5: '經明行修　心不紛亂',
    v4: '諸欲去，常得明經',
    other: null,
  },
  {
    no: '75',
    v1: 'སྙིང་རྗེ་ཆེན་པོ་ཡོངས་སུ་བསྒོམས་པ་དང་ལྡན་ཞིང་སེམས་འཇམ་པ་་་་་་',
    v2: '常行大悲　其心潤澤',
    v3: '大悲所熏　心意柔潤',
    v5: '大慈伏意　不起諸想',
    v4: '常柔軟心，悉得諸慈哀',
    other: null,
  },
  {
    no: '76',
    v1: 'སྒྲིབ་པ་མེད་པ་རྟོགས་པར་ཁོང་དུ་ཆུད་ཅིང་སྡིག་པའི་ཆོས་ཐམས་ཅད་བསལ་ཏེ་དགེ་བའི་ཆོས་ལ་རབ་ཏུ་གཞོལ་བ་་་་་་',
    v2: '住正法界　離諸罪難',
    v3: '向正法界　滅除諸難',
    v5: '（伏心在道　經意不疲）',
    v4: '諸所惡法，悉除去，通利入佛經中，悉覺知',
    other: null,
  },
  {
    no: '77',
    v1: 'དུས་གསུམ་དུ་གཏོགས་པའི་ཆོས་ཟབ་མོ་བསྟན་པ་དང་མཐུན་པ་་་་་་',
    v2: '說甚深法　一切和合',
    v3: '說甚深法　一切和合',
    v5: '-',
    v4: '聽受諸經，悉入中',
    other: null,
  },
  {
    no: '78',
    v1: 'ཁྲོ་ཞིང་མཁོན་དུ་འཛིན་པ་དང་བྲལ་ཏེ།ཁེངས་པ་དང་འཁྲུགས་པ་དང་རྣམ་པར་བྲལ་བ་་་་་་',
    v2: '離我諍心　無有忿恨',
    v3: '離我諍心　無有忿恨',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '79',
    v1: 'ལྷ་དང་འཇིག་རྟེན་དུ་བཅས་པས་ཕྱག་བྱ་བའི་གནས་སུ་གྱུར་་་་་་',
    v2: '諸天及人　所應敬禮',
    v3: '一切敬禮　天人師仰',
    v5: '學爲儒林　養徒以德',
    v4: '無不歸仰供養者，天上、世間皆悉然',
    other: null,
  },
  {
    no: '80',
    v1: 'ཐོབ་པར་དཀའ་བ་དང་ཐིབས་པོ་མེད་པ་རབ་ཏུ་ཐོབ་ཅིང་དགེ་བའི་རྩ་བ་ཐམས་ཅད་ཀྱིས་མངོན་པར་འཕགས་པ་་་་་་',
    v2: '善根超出　無能至頂',
    v3: '得無上善　莫能見頂',
    v5: '志仰高大　積德無厭',
    v4: '心念高才，明諸功德法，無有能勝者',
    other: null,
  },
  {
    no: '81',
    v1: 'འདོད་ཆགས་དང་ཞེ་སྡང་དང་གཏི་མུག་མེད་ཅིང་ཚེར་མ་དང་བྲལ་བ་་་་་་',
    v2: '疾得翦除　三毒之刺',
    v3: '拔三毒刺無賊害心',
    v5: '三毒消滅　無賊害心',
    v4: '疾遠離於婬泆、瞋怒、愚癡',
    other: null,
  },
  {
    no: '82',
    v1: 'བསམ་གཏན་དང་རྣམ་པར་ཐར་པ་དང་ཏིང་ངེ་འཛིན་དང་སྙོམས་པར་འཇུག་པ་དག་གིས་རབ་ཏུ་གཡོགས་པ་་་་་་',
    v2: '以定解脫　而爲蔭映',
    v3: '以道自蔭　入禪三昧',
    v5: '以道自蔭　入禪三昧',
    v4: '道覆蓋，得禪，佪入三昧',
    other: null,
  },
  {
    no: '83',
    v1: 'ཆོས་ཐམས་ཅད་ལ་མངོན་པར་ཤེས་པའི་མེ་ཏོག་རྒྱས་པས་མེ་ཏོག་ལྟ་བུར་གྱུར་་་་་་',
    v2: '神通等法　如華開敷',
    v3: '-',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '84',
    v1: 'སྐྱེས་བུ་ཆེན་པོའི་མཚན་སུམ་ཅུ་རྩ་གཉིས་ཀྱི་མེ་ཏོག་ཤིན་ཏུ་རྒྱས་པ་་་་་་',
    v2: '衆相如華　具三十二',
    v3: '開淨如華　相好滿具',
    v5: '三十二相　諸好滿具',
    v4: '莊身，得三十二相',
    other: null,
  },
  {
    no: '85',
    v1: 'སྙིང་པོ་བྱང་ཆུབ་དུ་གཞོལ་ཞིང་། སངས་རྒྱས་ཀྱི་ཆོས་བཙལ་བ་ཐམས་ཅད་འབྲས་བུ་ཡོད་དེ། འབྲས་བུའི་དམ་པ་རབ་ཏུ་ཐོབ་པ་་་་་་',
    v2: '獲最勝法　證菩提道',
    v3: '起道樹行　成無上果',
    v5: '起道樹行　成無上果',
    v4: '得華實，悉具足於佛經中',
    other: null,
  },
  {
    no: '86',
    v1: 'སངས་རྒྱས་ཀྱི་ཡེ་ཤེས་ཉམས་སུ་མྱོང་སྟེ།ཆོས་ཀྱི་རྒྱུན་ལ་མཉམ་པར་བཞག་པ་་་་་་',
    v2: '得預法流　入佛智海',
    v3: '得正法流　入佛智海',
    v5: '得正溝流　入佛海智',
    v4: '入佛經流淵中，悉得佛智',
    other: null,
  },
  {
    no: '87',
    v1: 'སངས་རྒྱས་ཀྱི་ཆོས་ཐམས་ཅད་རོ་གཅིག་པའི་ཕྱིར་སེ་གོལ་གཏོགས་པ་ཙམ་གྱིས་ཁོང་དུ་ཆུད་པ་་་་་',
    v2: '疾悟諸佛　一味之法',
    v3: '悉得諸佛　不壞正法',
    v5: '開心受法　得一味道',
    v4: '早開經門，一味無有異',
    other: null,
  },
  {
    no: '88',
    v1: 'ཆོས་ཐམས་ཅད་ཀྱི་ཚིག་ཤིན་ཏུ་བསྟན་པ་ལ་མཁས་ཤིང་ཆོས་ཐམས་ཅད་ཀྱིས་རྒྱས་པའི་ཚིག་གི་ལས་དང་ལྡན་པ་་་་',
    v2: '語業滿足　巧能演說',
    v3: '入佛智海　問答無窮',
    v5: '入佛淵智　所問無窮',
    v4: '所問慧者，多所解，悉會於佛經道中',
    other: null,
  },
  {
    no: '89',
    v1: 'ཆོས་ཐམས་ཅད་འབྱོར་པ་དང་ལྡན་ཞིང་སྤོབས་པ་མང་བར་གྱུར་་་་',
    v2: '具足辯才　演一切法',
    v3: '得如來辯　不可窮盡',
    v5: '-',
    v4: '所道智，悉具足，開入功德法中',
    other: null,
  },
  {
    no: '90',
    v1: 'གོང་ནས་གོང་དུ་དམིགས་པ་ལ་རབ་ཏུ་བརྩོན་ཞིང་དགེ་བའི་རྩ་བ་མི་ཟད་པ་་་་',
    v2: '方便增長　善根無盡',
    v3: '善根無盡　境界無上',
    v5: '入深佛藏　無盡之法',
    v4: '悉重持諸功德法，無有盡𣩠時，無有能過者',
    other: null,
  },
  {
    no: '91',
    v1: 'སྐྱེ་བོ་ཐམས་ཅད་ཡོངས་སུ་བསྒྲལ་བ་ལ་ཟམ་པར་རེད་པ་་་་',
    v2: '廣度一切　猶如橋梁',
    v3: '興造法橋　度人不休',
    v5: '興造法橋　度人不休',
    v4: '得諸經極過度，人如橋梁，過人無有極止時',
    other: null,
  },
  {
    no: '92',
    v1: 'འགྲོ་བ་ཀུན་གྱི་སེམས་དང་བསམ་པ་ལ་མཁས་ཤིང་བག་ལ་ཉལ་བ་དང་ཀུན་ནས་འཁོར་བ་མེད་པ་་་་',
    v2: '得善意欲　洗除惑垢',
    v3: '洗濯塵垢　意解淸淨',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '93',
    v1: 'གཟུགས་དང་སྒྲ་དང་དྲི་དང་རོ་དང་རེག་བྱ་ལ་སྲེད་པ་རབ་ཏུ་བྱང་བ་་་་',
    v2: '五欲圃中　耘除愛草',
    v3: '芸除穢惡　不生欲根',
    v5: '耘除穢惡　不生欲根',
    v4: '心無所拘著，不樂於五音樂、五所思',
    other: null,
  },
  {
    no: '94',
    v1: 'སྲེད་པ་ཤིན་ཏུ་མེད་ཅིང་མྱ་ངན་མེད་པ་རབ་ཏུ་ཐོབ་པ་་་་',
    v2: '永離貪愛　不生憂怖',
    v3: '心得歡喜　永除憂惱',
    v5: '-',
    v4: '心無所愁憂，悉得深智本根',
    other: null,
  },
  {
    no: '95',
    v1: 'སངས་རྒྱས་ཀྱི་བྱང་ཆུབ་ཡོངས་སུ་མི་གཏོང་བ་ལ་ཤིན་ཏུ་བརྩོན་པ་་་་',
    v2: '勤修諸行　趣佛菩提',
    v3: '勤修衆善　具足菩提',
    v5: '得周滿持　道法備具',
    v4: '無不精進者，莫令離於佛諸經',
    other: null,
  },
  {
    no: '96',
    v1: 'སྐྱེས་བུ་ཆེན་པོའི་མཚན་སུམ་ཅུ་རྩ་གཉིས་ཀྱིས་བརྒྱན་པ་་་་',
    v2: '三十二相　以爲嚴好',
    v3: '三十二相　而自莊嚴',
    v5: '-',
    v4: '莊嚴於三十二相，悉逮得',
    other: null,
  },
  {
    no: '97',
    v1: 'སྦྱངས་པའི་ཕ་རོལ་ཏུ་ཕྱིན་པ་ཐོབ་པས་རྒྱན་མེད་པ་་་་',
    v2: '捨諸飾好　具頭陀行',
    v3: '究竟得到　頭陀彼岸',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '98',
    v1: 'ཆོས་ལ་དགའ་ཞིང་མོས་པ་དང་སྤྲོ་བས་དགའ་བ་མང་བ་་་་',
    v2: '以法自娛　歡愛不捨',
    v3: '淸淨法樂　以道自娛',
    v5: '捨非常樂　五欲自娛',
    v4: '樂喜深經',
    other: null,
  },
  {
    no: '99',
    v1: 'འདུས་བྱས་ཀྱི་དངོས་པོ་ཐམས་ཅད་ལ་མི་དགའ་བ་མང་བ་་་་',
    v2: '有爲事中　心無所樂',
    v3: '於有爲法　心生厭離',
    v5: '（離諸恐怖　無復憂戚）',
    v4: '（莫復愁憂）',
    other: null,
  },
  {
    no: '100',
    v1: 'སངས་རྒྱས་ཀྱི་བདེ་བའི་ཡོ་བྱད་ཐམས་ཅད་རབ་ཏུ་ཐོབ་པས་ཤིན་ཏུ་བདེ་བར་གྱུར་་་་་་་་',
    v2: '常得安樂　樂供養佛',
    v3: '得無上樂　淡泊無患',
    v5: '安快如佛　惔怕無患',
    v4: '安隱，逮得如佛安隱',
    other: null,
  },
  {
    no: '101',
    v1: 'ཡེ་ཤེས་ཀྱི་རྩ་བ་རབ་ཏུ་ཐོབ་སྟེ། སྡུག་བསྔལ་ཞི་བར་བྱེད་པ་་་་་་་་',
    v2: '獲根本智　滅除衆苦',
    v3: '滅除衆苦　得佛智慧',
    v5: '得泥洹道　免度諸厄',
    v4: '滅𣩠諸勤苦，悉見正眞道',
    other: null,
  },
  {
    no: '103',
    v1: 'ཤིན་ཏུ་མྱ་ངན་མེད་པའི་ཆོས་ཅན་དུ་གྱུར་ཏེ། ཐ་དད་པ་མེད་པར་ཁོང་དུ་ཆུད་པ་་་་་་་་',
    v2: '知身空寂　離乖諍法',
    v3: '知身空寂　解脫衆苦',
    v5: '知空非身　無苦痛意',
    v4: '念無常，悉入虛空中，盡究竟於佛經，莫復還',
    other: null,
  },
  {
    no: '104',
    v1: 'སངས་རྒྱས་དང་བྱང་ཆུབ་སེམས་དཔའ་ཐམས་ཅད་ལ་མོས་པ་མང་བ་་་་་་་',
    v2: '於佛菩薩　常生淨信',
    v3: '歡喜恭敬　諸佛菩薩',
    v5: '意行質直　愛好道法',
    v4: '愛樂於佛經',
    other: null,
  },
  {
    no: '105',
    v1: 'མི་དགེ་བའི་བཤེས་གཉེན་གྱི་བྱ་བ་ལ་མོས་པ་ཆུང་བ་་་་་',
    v2: '於不善事　不生樂著',
    v3: '遠離鄙惡　以善自嚴',
    v5: '去醜惡行　以善自嚴',
    v4: '莫墮醜惡中',
    other: null,
  },
  {
    no: '106',
    v1: 'སངས་རྒྱས་དང་བྱང་ཆུབ་སེམས་དཔའ་ཐམས་ཅད་ཀྱི་མཛད་པ་ཤེས་པ་་་་་',
    v2: '於佛菩薩　能知恩德',
    v3: '常念諸佛　菩薩恩德',
    v5: '念佛恩德　行菩薩行',
    v4: '報恩於諸菩薩',
    other: null,
  },
  {
    no: '107',
    v1: 'མི་དགེ་བའི་ལྟ་བ་ལ་དྲིན་དུ་གཟོ་བ་མེད་པ་་་་་',
    v2: '於有惡人　不加其報',
    v3: '常見賢聖　不作衆惡',
    v5: '降心伏意　棄捐諸惡',
    v4: '無有慳貪，悉示人於正道',
    other: null,
  },
  {
    no: '108',
    v1: 'མ་ལུས་པའི་མཐར་ཐུག་པར་བྱ་བ་ལ་བརྩོན་ཞིང་ཞི་བ་དང་དུལ་བ་ལ་གཞོལ་བ་་་་་',
    v2: '調柔寂靜　畢竟第一',
    v3: '寂靜調伏　究竟無餘',
    v5: '多聞戒具　誨人不倦',
    v4: '受諸經，悉究竟得',
    other: null,
  },
  {
    no: '109',
    v1: 'ཚངས་པའི་དམ་པར་གྱུར་ཏེ་སྡིག་པ་སྤངས་པ་་་་་',
    v2: '永持梵行　離一切惡',
    v3: '永持梵行　離一切惡',
    v5: '遠去邪見　入八正道',
    v4: '諸惡根本，悉消盡儩，究竟諸經',
    other: null,
  },
  {
    no: '110',
    v1: 'མ་ལུས་པའི་མཐར་ཐུག་པར་བྱ་བ་ལ་བརྩོན་ཞིང་དཀའ་ཐུབ་ལ་ཤིན་ཏུ་གཞོལ་བ་་་་་',
    v2: '依於苦行　至究竟處',
    v3: '向正真道　究竟解脫',
    v5: '意行具足　所欲者成',
    v4: '所求願，盡悉得，所作爲皆成足',
    other: null,
  },
  {
    no: '111',
    v1: 'སངས་རྒྱས་ཀྱི་བྱང་ཆུབ་ཡོངས་སུ་མི་གཏོང་བའི་ཕྱིར་བརྟུལ་ཞུགས་དམ་པོར་གྱུར་་་་་',
    v2: '堅持志行　不捨佛道',
    v3: '堅固精勤　不退佛道',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '112',
    v1: 'རང་བྱུང་གི་ཆོས་ཡོངས་སུ་བཙལ་བ་ལ་གོ་ཆ་བཟང་པོ་ཤིན་ཏུ་བགོས་པ་་་་་',
    v2: '常服善鎧　趣無師法',
    v3: '誓服法鎧　得無師法\t誓被法鎧　不違本願',
    v5: '誓被法鎧　不違本願',
    v4: '受鎧，悉具足於佛經',
    other: null,
  },
  {
    no: '113',
    v1: 'མི་དགེ་བའི་ལས་བྱ་བ་ཐམས་ཅད་ལ་གོ་གྱོན་པ་མེད་པ་་་་་',
    v2: '永離一切　不善之業',
    v3: '遠離衆惡　親近善法',
    v5: '勇於道義　成四無畏',
    v4: '黠健，所作爲莫墮衆惡中',
    other: null,
  },
  {
    no: '114',
    v1: 'ཕས་ཀྱི་རྒོལ་བ་ཐམས་ཅད་ཤིན་ཏུ་ཚར་གཅོད་པ་་་་་',
    v2: '於諸異論　悉能摧伏',
    v3: '得無上辯　摧伏外道',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '115',
    v1: 'སྤྱོད་ལམ་བཅོས་པ་མེད་ཅིང་འཚོ་བ་དག་པ་་་་་',
    v2: '得淸淨命　不矯威儀',
    v3: '得淸淨命　威儀不異',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '116',
    v1: 'ཐོགས་པ་མེད་པའི་ཆོས་ཀྱི་འཁོར་ལོ་བསྐོར་བའི་ཆོས་ཀྱི་རྒྱལ་པོ་གྱུར་་་་་',
    v2: '得爲法王　恒轉正法',
    v3: '逮淨法王　轉無礙輪\t得奉聖化　如正道教',
    v5: '得奉聖化　如正道教',
    v4: '自致爲經中王，自然轉經，說道無有休絕時',
    other: null,
  },
  {
    no: '117',
    v1: 'སངས་རྒྱས་ཀྱི་སྲས་ཆོས་ལས་སྐྱེས་པའི་ཆོས་ཀྱི་སྤྲུལ་པ་་་་་',
    v2: '從法化生　而爲佛子',
    v3: '履佛子行　化生法中',
    v5: '履佛子行　化生法中',
    v4: '作佛子，常化生於經中',
    other: null,
  },
  {
    no: '118',
    v1: 'རྣམ་པར་གདོན་མི་ཟ་བའི་བློ་ཅན་དུ་གྱུར་ཏེ། གྲོང་གི་ཆོས་སྤངས་པ་་་',
    v2: '善能明斷　不行惡法',
    v3: '永離愛欲　深解佛法',
    v5: '明於道理　助利天下',
    v4: '明於深經中；所問慧，莫不解，遣承用者',
    other: null,
  },
  {
    no: '119',
    v1: 'མི་དགེ་བའི་ཆོས་ཀྱི་སྤྱོད་པ་ཐམས་ཅད་ལ་བཟང་པོ་ཡིད་ལ་བྱེད་པ་་་',
    v2: '恒守正念　習行衆善',
    v3: '常得正念　修行衆善',
    v5: '忠正順善　無固賊心',
    v4: '念正，莫有惡，無令遠離於諸菩薩',
    other: null,
  },
  {
    no: '120',
    v1: 'གདུལ་དཀའ་བའི་སེམས་དང་ལྡན་པར་གྱུར་ཏེ། མཐུ་བོ་ཆེའི་ལུས་དང་ལྡན་པ་་་',
    v2: '得堅固身　心無所屈',
    v3: '得金剛身　心不可沮',
    v5: '持戒完具　心無虧缺',
    v4: '身體無有與等者，悉令人善，無有能過者',
    other: null,
  },
  {
    no: '121',
    v1: 'ཡོན་ཏན་གྱི་རྗེས་སུ་འབྲང་བར་མཐུན་པ་་་',
    v2: '功德共聚',
    v3: '功德自在',
    v5: '諸善普立',
    v4: '常令與善功德相値',
    other: null,
  },
  {
    no: '122',
    v1: 'ལྷ་དང་བཅས་པའི་འཇིག་རྟེན་གྱི་བསྔགས་པར་འོས་པ་་་',
    v2: '應爲天人　之所歎仰',
    v3: '得上妙色　天人讚歎',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '123',
    v1: 'སྒྲིབ་པ་མེད་པའི་ཚུལ་གྱིས་ཆོས་ཀྱི་དབྱིངས་སུ་ཆུད་པ་་་་་་',
    v2: '入深法界　心無障礙',
    v3: '入深法界　心無障礙',
    v5: '如戒法求　無得疑妄',
    v4: '入佛法處，無有謬誤時',
    other: null,
  },
  {
    no: '124',
    v1: 'སངས་རྒྱས་ཀྱི་ཆོས་ཐམས་ཅད་ཀྱི་སྒོར་ཕྱིན་པ་་་་་་',
    v2: '入於一切　佛法之門',
    v3: '入總持門　見諸佛法',
    v5: '入總持門　悉見諸法',
    v4: '至佛經門',
    other: null,
  },
  {
    no: '125',
    v1: 'སངས་རྒྱས་ཀྱི་ཐེག་པ་དུས་གསུམ་དུ་མཉམ་པ་ཉིད་ཀྱི་ནང་དུ་ཕྱིན་པ་་་་་་',
    v2: '得入佛乘　三世平等',
    v3: '入一佛乘　明達三世',
    v5: '昇佛聖堂　深行微妙',
    v4: '入佛智慧內',
    other: null,
  },
  {
    no: '126',
    v1: 'བསོད་ནམས་ཀྱི་ཕ་རོལ་ཏུ་ཕྱིན་པ་འཐོབ་ཅིང་ཕྱིར་སྤང་བ་མེད་པ་་་་་་',
    v2: '常不捨離　勝功德法',
    v3: '不捨衆善　永度彼岸',
    v5: '得般若意　無望無惜',
    v4: '無有逆難，悉入般若波羅蜜經中',
    other: null,
  },
  {
    no: '127',
    v1: 'སེམས་ཅན་དམྱལ་བ་དང་བྱོལ་སོང་གི་སྐྱེ་གནས་དང་གཤིན་རྗེའི་འཇིག་རྟེན་ལས་ཕྱིར་སྤངས་པ་་་་་་',
    v2: '永得捨離　三惡道苦',
    v3: '超出衆難　度三惡道',
    v5: '離三惡道　無飢渴想',
    v4: '莫復墮泥犂、禽獸、薜荔監樓惡道中',
    other: null,
  },
  {
    no: '128',
    v1: 'ཉོན་མོངས་པ་ཐམས་ཅད་ཀྱིས་སྟོངས་པ་་་་་་',
    v2: '其心淸淨　空無煩惱',
    v3: '其心淸淨　空無煩惱',
    v5: '皆得至空　無欲之性',
    v4: '空於愛欲中',
    other: null,
  },
  {
    no: '129',
    v1: 'ཆོས་དཀར་པོ་ཐམས་ཅད་ཀྱིས་ཡོངས་སུ་རྒྱས་པ་་་་་',
    v2: '具足成滿　一切善法',
    v3: '具足成滿　一切善法',
    v5: '一切成滿　道品之法',
    v4: '滿諸功德中',
    other: null,
  },
  {
    no: '130',
    v1: 'སངས་རྒྱས་ཀྱི་ཆོས་ཀྱི་སྤྱོད་པ་ཐམས་ཅད་ལ་རིམ་གྲོར་བྱེད་པ་་་་་',
    v2: '恭敬修行　一切佛法',
    v3: '爲法供養　志在佛道',
    v5: '爲法供養　志在大道',
    v4: '奉行佛道事',
    other: null,
  },
  {
    no: '131',
    v1: 'མི་དགེ་བའི་ཆོས་མཆོད་པ་ཐམས་ཅད་ལ་རག་མ་ལུས་པ་་་་་',
    v2: '不行一切　不善之法',
    v3: '遠離一切　諸不善行',
    v5: '',
    v4: '',
    other: null,
  },
  {
    no: '132',
    v1: 'དབང་པོ་དབེན་པའི་སྤྱོད་པ་དང་ལྡན་ཞིང་ཁྲེལ་ཡོད་པ་་་་་',
    v2: '具慚恥行　藏護諸根',
    v3: '慚愧正行　調伏諸根',
    v5: '廉潔知恥　所作不妄',
    v4: '無不慚愧於愛欲者',
    other: null,
  },
  {
    no: '133',
    v1: 'བྱམས་པ་ལ་གནས་ཤིང་ངོ་ཚ་མེད་པ་ཡོངས་སུ་སྤངས་པ་་་་་',
    v2: '捨離無慚　住大慈道',
    v3: '離無慚愧　普行大慈',
    v5: '-',
    v4: '心所念惡，悉棄捐，莫不慈哀者',
    other: null,
  },
  {
    no: '134',
    v1: 'ཟང་ཟིང་མེད་པའི་སེམས་དང་ལྡན་ཞིང་སྨོན་ལམ་ཐམས་ཅད་ཕུན་སུམ་ཚོགས་པ་་་་་',
    v2: '滿足其願　心無羡欲',
    v3: '知節少欲　情無所著',
    v5: '知節少欲　情無所著',
    v4: '所願，無不悉得者，心無沾汙',
    other: null,
  },
  {
    no: '135',
    v1: 'ཏིང་ངེ་འཛིན་ཉམས་སུ་བདེ་བ་ཐམས་ཅད་ཐོབ་པ་་་་་',
    v2: '莫不獲得　諸三昧味',
    v3: '具足成滿　無願三昧',
    v5: '知身幻法　好惡無異',
    v4: '-',
    other: null,
  },
  {
    no: '136',
    v1: 'སྙིང་རྗེ་ཆེན་པོ་ཡོངས་སུ་བསྒོམས་པའི་སེམས་དང་ལྡན་ཞིང་སེམས་འཇམ་པ་་་་་',
    v2: '大悲所熏　心意柔軟',
    v3: '大悲所熏　心意柔軟',
    v5: '-',
    v4: '柔軟心，無不愍傷者',
    other: null,
  },
  {
    no: '137',
    v1: 'འཇིག་རྟེན་གྱི་སྲེད་པ་དང་བྲལ་ཏེ་སྣུམ་བག་མེད་པའི་སེམས་་་་་',
    v2: '心無染著　絕世貪愛',
    v3: '永得遠離　世間愛味',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '138',
    v1: 'ཆོས་ལ་དགའ་བ་དང་རབ་ཏུ་དགའ་བས་ཡོངས་སུ་རྒྱས་ཤིང་བསམ་གཏན་གྱི་ཟས་ཟ་བ་་་་་',
    v2: '禪悅爲食　法喜充滿',
    v3: '禪悅爲食　法喜充滿',
    v5: '悉得諸經　諸佛法味',
    v4: '如禪食足   常飽於經',
    other: null,
  },
  {
    no: '139',
    v1: 'སྐྱེས་བུ་ཆེན་པོའི་མཚན་རོ་བྲོ་བའི་མཆོག་ཐོབ་པ་་་་་',
    v2: '得佛上味',
    v3: '得佛上味',
    v5: '味味如佛',
    v4: '飽味如佛',
    other: null,
  },
  {
    no: '140',
    v1: 'སངས་རྒྱས་ཀྱི་ཆོས་ཀྱི་ཕ་རོལ་ཏུ་ཕྱིན་ཅིང་བྱ་བ་བྱས་པ་་་་་',
    v2: '所作皆辨　具諸佛法',
    v3: '德行充盈　成十種力',
    v5: '德行充盈　成十種力',
    v4: '所作爲，悉成足，入佛經極過去',
    other: null,
  },
  {
    no: '141',
    v1: 'སངས་རྒྱས་ཀྱི་ཆོས་ཐམས་ཅད་ལ་ཡང་དག་པར་གཞོལ་ཞིང་སྤོབས་པ་མི་ཟད་པ་དང་ལྡན་པ་་་་',
    v2: '得無盡辯　廣宣法要',
    v3: '得無盡辯　深達佛法',
    v5: '悉令通佛　十二部經',
    v4: '所說道無有盡時，悉入佛諸深經中',
    other: null,
  },
  {
    no: '142',
    v1: 'སངས་རྒྱས་ཀྱི་ཡེ་ཤེས་ཉམས་སུ་མྱོང་སྟེ། ཁམས་གསུམ་ཐམས་ཅད་ནས་བྱུང་བ་་་་',
    v2: '深入佛智　永出三界',
    v3: '深入佛智　永出三界',
    v5: '一切究竟　得三甘露',
    v4: '出於三處色；無常、空中，悉受得佛智',
    other: null,
  },
  {
    no: '143',
    v1: 'དུས་གསུམ་མཉམ་པ་ཉིད་ཀྱིས་ཐམས་ཅད་མཁྱེན་པའི་ཡེ་ཤེས་ལ་འབོགས་པ་་་་',
    v2: '入一切智　知三世等',
    v3: '深入佛道　等達三世',
    v5: '身口意淨　等於三塗',
    v4: '入佛智慧中，過去、當來、今現在，悉平等',
    other: null,
  },
  {
    no: '144',
    v1: 'འོད་མཐའ་ཡས་པ་དང་ལྡན་ཞིང་ལུས་དང་སེམས་དྲི་མ་མེད་པ་་་་',
    v2: '身心無垢　內外光潔',
    v3: '身心無垢　光明無量',
    v5: '盪除心垢　見生死際',
    v4: '洗除心垢，悉令去明極，照至邊',
    other: null,
  },
  {
    no: '145',
    v1: 'མུ་མེད་པར་ཕྱིན་པ་སྟེ་ཡོངས་སུ་གདུང་བ་སེལ་བ་་་་',
    v2: '捨離衆惱　一切皆盡',
    v3: '離煩惱熱　得淸涼定',
    v5: '得淸涼定  滅一切苦',
    v4: '遠離於熱，極過度去',
    other: null,
  },
  {
    no: '146',
    v1: 'ཤིན་ཏུ་བསིལ་བར་གྱུར་ཏེ། བླ་ན་མེད་པའི་བསིལ་བའི་དངོས་པོ་ཁོང་དུ་ཆུད་པ་་་་',
    v2: '證無上法　究竟淸涼',
    v3: '究竟解脫　無上淸涼',
    v5: '心冷愛除　無復情欲',
    v4: '作人中將，得極明涼好處',
    other: null,
  },
  {
    no: '147',
    v1: 'སངས་རྒྱས་ཀྱི་ཆོས་ཀྱི་གཏམ་གྱི་རྗེས་སུ་འགྲོ་ཞིང་ཆོས་ཀྱི་དབྱིངས་དང་འདྲིས་པ་་་་',
    v2: '順佛所說　總持不忘',
    v3: '得總持門　攝一切法',
    v5: '博解諸法　得無漏忘',
    v4: '解於諸經處，盡求索智，悉攬持諸慧',
    other: null,
  },
  {
    no: '148',
    v1: 'སངས་རྒྱས་ཐམས་ཅད་དང་འགྲོགས་པ་རབ་ཏུ་ཐོབ་སྟེ་སྒྲིབ་པ་མེད་པའི་མིག་དང་ལྡན་པ་་་་',
    v2: '得無礙眼　見一切佛',
    v3: '悉得佛眼　見諸最勝',
    v5: '常與佛會　行七覺意',
    v4: '與諸佛共會，心無所罣礙',
    other: null,
  },
  {
    no: '149',
    v1: 'ཀུན་ཏུ་མཛེས་པས་ཀུན་ཏུ་བཟང་པོ་་་་',
    v2: '皆如普賢　端正嚴好',
    v3: '悉覩十方　端正如佛',
    v5: '悉覩十方　眼無障蔽',
    v4: '眼所視無所罣礙，見無極處',
    other: null,
  },
  {
    no: '150',
    v1: 'འགྲོ་བ་ཀུན་གྱིས་མཆོད་པར་འོས་ཤིང་མཆོད་རྟེན་ལྟ་བུ་་་་',
    v2: '尊重如塔　受天人供',
    v3: '尊重如塔　受天人敬',
    v5: '-',
    v4: '-',
    other: null,
  },
  {
    no: '151',
    v1: 'ལྷ་དང་བཅས་པའི་འཇིག་རྟེན་གྱིས་ལྟ་བ་་་་',
    v2: '諸天及人　所共瞻仰',
    v3: '尊貴如佛　天人宗仰',
    v5: '-',
    v4: '皆使行經，無有與等者',
    other: null,
  },
  {
    no: '152',
    v1: 'ལྷ་དང་བཅས་པའི་འཇིག་རྟེན་གྱིས་སྤྱི་གཙུག་ལྟར་མི་སྣང་བ་་་',
    v2: '一切天人　無能見頂',
    v3: '得道如佛　無能見頂',
    v5: '得道如佛　莫能見頂',
    v4: '無有能逮見佛頭上者，天上、',
    other: null,
  },
  {
    no: '153',
    v1: 'ཐམས་ཅད་མཁྱེན་པ་ཉིད་དུ་དོན་དང་མཐུན་པ་་་་་་་',
    v2: '所行無逆　成一切智',
    v3: '履行正路　究暢道意',
    v5: '施行福祐　究暢道意',
    v4: '繞極善，所作爲皆究竟儩，明經',
    other: null,
  },
  {
    no: '154',
    v1: 'སངས་རྒྱས་ཀྱི་བྱང་ཆུབ་ཏུ་མོས་པའི་རབ་དང་ལྡན་པ་་་་་་་',
    v2: '勤求佛道　心無懈歇',
    v3: '得一向意　勤求佛道',
    v5: '得一向意　不斷四喜',
    v4: '所作爲，心常勇，未嘗遠離於佛道',
    other: null,
  },
  {
    no: '155',
    v1: 'ཡོན་ཏན་གྱི་ཕ་རོལ་ཏུ་ཕྱིན་པས་ཡོན་ཏན་མི་ཟད་པ་་་་་',
    v2: '衆德悉具　稱歎無盡',
    v3: '度功德岸　歎無窮盡',
    v5: '念佛恩德　行法供養',
    v4: '所作爲功德不可計、威神不可計，功中極過度',
    other: null,
  },
  {
    no: '156',
    v1: 'མཚན་ཉིད་མེད་པའི་ཆོས་ལ་གཞོལ་ཞིང་ཡན་ལག་དམ་པ་ཕུན་སུམ་ཚོགས་པ་་་་་',
    v2: '成就佛身　證無相法',
    v3: '光明神德　如佛法身',
    v5: '光明神德　如佛法身',
    v4: '身體，悉具足，如佛經身',
    other: null,
  },
  {
    no: '157',
    v1: 'དྲི་མ་མེད་པའི་མཐར་ཕྱིན་ཅིང་རྫུ་འཕྲུལ་གྱི་རྐང་པས་ཕ་རོལ་ཏུ་ཕྱིན་པ་་་་་',
    v2: '具神足力　所行無礙',
    v3: '得四神足　究竟解脫',
    v5: '得四神足　周遍十方',
    v4: '悉得佛神足，念飛無所復罣礙，悉入具',
    other: null,
  },
  {
    no: '158',
    v1: 'བསམ་པ་ལ་རྙོག་པ་མེད་ཅིང་ལུས་ཀྱི་འདུ་བྱེད་ཤིན་ཏུ་བདེ་བ་་་་་',
    v2: '身得安隱　心無動亂',
    v3: '休息諸行　心淨無穢',
    v5: '去離陰冥　無復五蓋',
    v4: '不復繫於愛欲、勤苦中，悉淨潔',
    other: null,
  },
  {
    no: '159',
    v1: 'ཕྱོགས་བཅུ་ཐམས་ཅད་དུ་མཐུ་ཆེན་པོ་ཐོབ་པར་གྱུར་ཏེ། ཐམས་ཅད་མཁྱེན་པའི་ཡེ་ཤེས་ལ་ཤིན་ཏུ་རྣམ་པར་སངས་རྒྱས་པའི་སངས་རྒྱས་་་་་',
    v2: '一切智覺　周顧十方',
    v3: '一切智覺　不捨十方',
    v5: '得佛十八　不絕之法  是爲菩薩　戒願俱行　兼愛博施　不捨十方」',
    v4: '得佛智慧，得十力',
    other: null,
  }],
}];



// WEBPACK FOOTER //
// ./src/components/data/vocabulariesPS.js